import { useAxios } from '@/composables/useAxios'
import { NUXT_APP_SERVICE_API_TOKEN } from '~/env';

const { axiosGlobal, loading } = useAxios();

export default defineNuxtRouteMiddleware((to, from) => {
    axiosGlobal.defaults.headers.common['Service-auth'] = NUXT_APP_SERVICE_API_TOKEN;
})